import { Component, ElementRef, AfterViewInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

export class MessageModalButton {
    id: any;
    title: string;
    look: string;
}

@Component({
    selector: 'message-modal',
    templateUrl: './message-modal.component.html'
})
export class MessageModalComponent {

    _show: boolean = false;
    _content: any;
    resolve: any;
    reject: any;

    @Input() set show(value: boolean) {
        this._show = value;
    }
    get show() {
        return this._show;
    }

    @Input() windowClass: string;
    @Input() title: string;
    @Input() message: string;
    @Input() messages: string[];
    @Input() buttons: MessageModalButton[];

    public get content(): any {
        return this._content;
    }

    public showModal(): Promise<any> {
        this.show = true;
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        })
    }

    close() {
        this.show = false;
        if (this.reject) {
            this.reject();
        }
    }

    onButtonClick(button: MessageModalButton) {
        this.show = false;
        if (this.resolve) {
            this.resolve(button.id);
        }
    }
}
